import Hex from './crypto/hex'
import SM3Digest from './crypto/sm3'
import { blobToArrayBuffer } from './format'

/**
 * 获取文件的 sm3 hash 值
 * @param file
 * @returns sm3hash 64位的字符串
 */
export async function getSm3HashOfFile(file: File) {
  let sm3 = new SM3Digest()
  const arrayBuffer = (await blobToArrayBuffer(file)) as ArrayBuffer
  const fileArr = new Uint8Array(arrayBuffer) as any
  sm3.update(fileArr, 0, fileArr.length)
  const sm3Hash = sm3.doFinal()
  const hashStr = Hex.encode(sm3Hash, 0, sm3Hash.length)
  return hashStr
}
